var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "sys-contract" },
    [
      _c("el-main", { staticClass: "main-box" }, [
        _c(
          "div",
          { staticClass: "systemp-content" },
          [_c(_vm.typeName, { ref: "contract", tag: "div" })],
          1
        )
      ]),
      _c(
        "el-aside",
        { staticClass: "saide-right", attrs: { width: "180px" } },
        [
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: { type: "danger", size: "small", loading: _vm.loading },
              on: { click: _vm.useTpl }
            },
            [_vm._v("下一步")]
          ),
          _c(
            "el-dropdown",
            { staticClass: "dropdown", attrs: { trigger: "click" } },
            [
              _c("span", { staticClass: "el-dropdown-link" }, [
                _vm._v("\n        签章设置"),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
              ]),
              _c(
                "el-dropdown-menu",
                {
                  staticStyle: { padding: "10px" },
                  attrs: { slot: "dropdown" },
                  slot: "dropdown"
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "保全章",
                          "active-color": "#ec1c1cb3"
                        },
                        model: {
                          value: _vm.needPresSign,
                          callback: function($$v) {
                            _vm.needPresSign = $$v
                          },
                          expression: "needPresSign"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "骑缝章",
                          "active-color": "#ec1c1cb3"
                        },
                        model: {
                          value: _vm.needQifengSign,
                          callback: function($$v) {
                            _vm.needQifengSign = $$v
                          },
                          expression: "needQifengSign"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5fd2fee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5fd2fee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/add/sysContract.vue
// module id = VGwG
// module chunks = 57